export class ApiError extends Error {
  readonly status: number;
  readonly code: string;

  constructor(status: number, code: string) {
    super(`${String(status)} ${code}`);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
  }

  isValidation(): boolean {
    return this.status >= 400 && this.status < 500;
  }

  isServer(): boolean {
    return this.status >= 500;
  }
}

export const humanErrorMessage = (err: unknown): string => {
  if (err instanceof ApiError) {
    if (err.isServer()) return 'Упс, что-то пошло не так. Попробуйте ещё раз через минуту.';
    return `Ошибка: ${err.code}`;
  }
  if (err instanceof Error) return err.message;
  return 'Неизвестная ошибка';
};
